import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { FileStack, Inbox, ShieldAlert, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Dashboard() {
  const { data: entities } = useQuery({ queryKey: ["cms-entities"], queryFn: async () => (await api.get("/cms/entities")).data });
  const { data: leadsData } = useQuery({ queryKey: ["cms-leads"], queryFn: async () => (await api.get("/cms/leads")).data });
  const { data: config } = useQuery({ queryKey: ["cms-config"], queryFn: async () => (await api.get("/cms/config")).data });

  const leads = leadsData?.leads || [];
  const newLeads = leads.filter((l) => l.status === "New").length;
  const indexing = config?.seo_indexing_enabled;

  const cards = [
    { label: "Content Entities", value: entities?.length ?? "…", icon: FileStack, to: "/sbt-panel-7391/entities" },
    { label: "Total Leads", value: leads.length, icon: Inbox, to: "/sbt-panel-7391/leads" },
    { label: "New Leads", value: newLeads, icon: Inbox, to: "/sbt-panel-7391/leads" },
  ];

  return (
    <div>
      <h1 className="text-3xl font-bold uppercase tracking-tight text-ink mb-1">Dashboard</h1>
      <p className="text-subtle text-sm mb-8">Sıfır Bir Tuning — content & leads overview</p>

      <div className={`mb-8 flex items-center gap-3 rounded-xl border p-4 ${indexing ? "border-emerald-500/30 bg-emerald-500/10" : "border-amber-500/30 bg-amber-500/10"}`} data-testid="indexing-status">
        {indexing ? <ShieldCheck className="text-emerald-400" /> : <ShieldAlert className="text-amber-400" />}
        <div>
          <p className="text-ink text-sm font-semibold">SEO Indexing: {indexing ? "ENABLED (production)" : "DISABLED (dev/staging)"}</p>
          <p className="text-xs text-subtle">{indexing ? "Published pages are index,follow." : "All public pages are noindex,follow. robots.txt blocks crawling."}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="card-surface p-6" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <c.icon className="text-copper mb-3" />
            <p className="text-3xl font-bold text-ink">{c.value}</p>
            <p className="text-sm text-subtle mt-1">{c.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
